import { useState, useEffect } from 'react';

const MobileFAB = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const whatsappLink =
    'https://wa.me/5511922305730?text=Olá,%20Daniel.%20Cheguei%20aqui%20através%20do%20seu%20site.%20Você%20pode%20me%20ajudar?';

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 md:hidden w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-green-600 text-white flex items-center justify-center shadow-xl shadow-green-500/30 active:scale-90 transition-all duration-300 cursor-pointer ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-fill text-2xl"></i>
    </a>
  );
};

export default MobileFAB;